<script lang="ts">
	let { label = 'Initializing WebGPU', quiet = false }: { label?: string; quiet?: boolean } =
		$props();
</script>

<div
	class="aqueduct-viewport-loading flex h-full w-full items-center justify-center text-zinc-900 dark:text-zinc-300"
>
	{#if !quiet}
		<div
			class="flex items-center gap-3 rounded border border-primary-200 bg-white/80 px-4 py-3 text-sm shadow-sm dark:border-zinc-800 dark:bg-zinc-900/80"
		>
			<i class="fa-solid fa-circle-notch fa-spin text-zinc-500 dark:text-zinc-400"></i>
			<span>{label}</span>
		</div>
	{/if}
</div>

<style>
	.aqueduct-viewport-loading {
		background-color: #fffeee;
	}

	:global(.dark) .aqueduct-viewport-loading {
		background-color: #101016;
	}
</style>
